import React from "react";
import { Link } from "react-router-dom";
import "./TermsOfServiceComp.css";

const TermsOfServiceComp = () => (
  <div className="mainTerms">
    <div className="txtTermsHead">Terms of Use</div>

    <div className="topTextTermsPart">
      <p>
        These Terms of Use (the “<strong>Terms</strong>”) govern your access to
        and use of thecryptohub.com and its subdomains (the “
        <strong>Site</strong>”) and the services made available through it,
        including our newsletter, podcast, blog, events and project listings
        (collectively, the “<strong>Services</strong>”), operated by
        TheCryptoHub Advisors, LLC (“<strong>we</strong>,” “
        <strong>us</strong>,” or “<strong>our</strong>”).
      </p>

      <p>
        PLEASE READ THESE TERMS CAREFULLY. BY ACCESSING OR USING THE SITE OR THE
        SERVICES, YOU AGREE TO BE BOUND BY THESE TERMS AND BY OUR{" "}
        <Link to="/user/privacy/policy">PRIVACY POLICY</Link>. IF YOU DO NOT
        AGREE TO ANY PART OF THESE TERMS, YOU MAY NOT ACCESS OR USE THE SITE OR
        THE SERVICES.
      </p>

      <p>
        <strong>1. Eligibility</strong>
      </p>
      <p>
        You must be at least 18 years old and legally capable of entering into a
        binding contract to use the Services. By using the Services, you
        represent and warrant that you meet these requirements and that your use
        of the Services does not violate any law or regulation applicable to
        you.
      </p>

      <p>
        <strong>2. Accounts</strong>
      </p>
      <p>
        Certain features require you to register an account. You agree to
        provide accurate and complete information, to keep it current, and to
        keep your credentials confidential. You are responsible for all activity
        that occurs under your account. Notify us promptly of any unauthorised
        use. We may suspend or terminate an account at our discretion, including
        where we believe these Terms have been breached.
      </p>

      <p>
        <strong>3. No Financial, Investment or Legal Advice</strong>
      </p>
      <p>
        All content on the Site, including project listings, blogs, podcasts,
        newsletters and event materials, is provided for general informational
        purposes only. Nothing on the Site constitutes financial, investment,
        legal, tax or accounting advice, nor an offer, solicitation or
        recommendation to buy or sell any digital asset, token or security.
        Digital assets are volatile and carry a risk of total loss. You are
        solely responsible for your own research and decisions, and you should
        consult qualified professional advisers before acting.
      </p>

      <p>
        <strong>4. Projects, Listings and Third Parties</strong>
      </p>
      <p>
        Projects featured, listed or otherwise referenced on the Site are
        independent third parties. While we operate a vetting and curation
        process, a listing is not an endorsement, guarantee or verification of
        any project, its team, its technology or its claims, and we do not
        assume responsibility for their conduct. The Site may contain links to
        third-party websites and services that we do not control; your use of
        them is at your own risk and subject to their terms.
      </p>

      <p>
        <strong>5. User Content</strong>
      </p>
      <p>
        You retain ownership of the content you submit to the Services,
        including project submissions, blogs, events and messages (“
        <strong>User Content</strong>”). By submitting User Content, you grant
        us a worldwide, non-exclusive, royalty-free licence to host, store,
        reproduce, publish, display and distribute it in connection with
        operating and promoting the Services. You represent that you own or have
        the necessary rights to your User Content and that it does not infringe
        the rights of any third party.
      </p>

      <p>
        <strong>6. Acceptable Use</strong>
      </p>
      <p>
        You agree not to: (a) use the Services for any unlawful, fraudulent or
        deceptive purpose, including market manipulation, money laundering or
        the financing of illegal activity; (b) post content that is unlawful,
        defamatory, infringing, misleading or abusive; (c) impersonate any person
        or entity or misrepresent your affiliation; (d) interfere with or
        disrupt the Site, its security, or its underlying infrastructure; (e)
        scrape, crawl or harvest data from the Site by automated means without
        our prior written consent; or (f) attempt to gain unauthorised access to
        any account, system or network connected to the Services.
      </p>

      <p>
        <strong>7. Intellectual Property</strong>
      </p>
      <p>
        The Site, the Services, and all associated content, trademarks, logos
        and software (excluding User Content) are owned by us or our licensors
        and are protected by intellectual property laws. We grant you a limited,
        revocable, non-exclusive, non-transferable licence to access and use the
        Site for your personal, non-commercial use. No other rights are granted.
      </p>

      <p>
        <strong>8. Fees</strong>
      </p>
      <p>
        Certain Services may be offered on a paid basis. Where fees apply, they
        will be disclosed to you before you incur them. Unless stated otherwise
        in writing, fees are non-refundable and exclusive of applicable taxes,
        which are your responsibility.
      </p>

      <p>
        <strong>9. Disclaimers</strong>
      </p>
      <p>
        THE SITE AND THE SERVICES ARE PROVIDED “AS IS” AND “AS AVAILABLE”
        WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED OR STATUTORY,
        INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
        PURPOSE, TITLE AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE SERVICES
        WILL BE UNINTERRUPTED, SECURE OR ERROR-FREE, OR THAT ANY CONTENT IS
        ACCURATE, COMPLETE OR CURRENT.
      </p>

      <p>
        <strong>10. Limitation of Liability</strong>
      </p>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE WILL NOT BE LIABLE FOR ANY
        INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, OR FOR
        ANY LOSS OF PROFITS, REVENUE, DATA, GOODWILL OR DIGITAL ASSETS, ARISING
        OUT OF OR RELATING TO YOUR USE OF THE SITE OR THE SERVICES. OUR TOTAL
        AGGREGATE LIABILITY FOR ALL CLAIMS RELATING TO THE SERVICES WILL NOT
        EXCEED THE GREATER OF THE AMOUNTS YOU PAID US IN THE TWELVE MONTHS
        PRECEDING THE CLAIM OR ONE HUNDRED US DOLLARS (USD $100).
      </p>

      <p>
        <strong>11. Indemnification</strong>
      </p>
      <p>
        You agree to indemnify, defend and hold harmless TheCryptoHub Advisors,
        LLC and its officers, directors, employees and agents from any claims,
        liabilities, damages, losses and expenses, including reasonable legal
        fees, arising out of or connected with your use of the Services, your
        User Content, or your breach of these Terms.
      </p>

      <p>
        <strong>12. Termination</strong>
      </p>
      <p>
        We may suspend or terminate your access to the Services at any time,
        with or without notice, including where we believe you have breached
        these Terms. Provisions that by their nature should survive termination
        will survive, including sections 5 through 11.
      </p>

      <p>
        <strong>13. Changes to These Terms</strong>
      </p>
      <p>
        We may update these Terms from time to time as our practices change.
        Your continued use of the Site after changes are posted constitutes your
        acceptance of the revised Terms, so please check back periodically for
        updates.
      </p>

      <p>
        <strong>14. Governing Law</strong>
      </p>
      <p>
        These Terms are governed by the laws of the State of Delaware, United
        States, without regard to its conflict of laws principles. You agree to
        the exclusive jurisdiction of the state and federal courts located in
        Delaware for any dispute arising out of or relating to these Terms,
        except where prohibited by applicable law.
      </p>

      <p>
        <strong>15. Contact</strong>
      </p>
      <p>
        Questions about these Terms can be sent to us through our{" "}
        <Link to="/user/contact">contact page</Link>.
      </p>
    </div>
  </div>
);

export default TermsOfServiceComp;
